import React from 'react';
import "../ExamChoiceByGender/ExamChoiceByGender.css";
import NavBar from '../../Layouts/NavBar';
import ExamChoiceBySponsor from './ExamChoiceBySponsor';

import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from '../../Context/UserInfoContext';
import MedicalContextProvider from '../../Context/MedicalContext';
import PacksProvider from "../../Context/PacksContext";
import Footer from '../../Layouts/Footer';

function ExamChoiceByGenderRoute() {
    
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
            <PacksProvider>
       <BrowserView>
            <div className="ExamChoiceByGenderRoutePage">
                <div className="ExamChoiceByGenderRouteNavBar">      
                    <NavBar/>
                </div>
                <div className="ExamChoiceByGenderRoute">
                    <ExamChoiceBySponsor/>
                </div>
                <div className="ExamChoiceByGenderContact">
                    <Footer/>
                </div>
            </div>
       </BrowserView>
        <MobileView>
            <div className="ExamChoiceByGenderRouteNavBar">      
                <NavBar/>
            </div>
            <div className="ExamChoiceByGenderRoute">
                <ExamChoiceBySponsor/>
            </div>
            <div className="ExamChoiceByGenderContact">
                <Footer/>
            </div>
</MobileView>
</PacksProvider>
</MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default ExamChoiceByGenderRoute;